import React, { useEffect, useState } from 'react'
import Page from '../../../../component/Page'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import TitlePage from '../../../../component/TitlePage'
import { Box, Button, Checkbox, FormControl, FormControlLabel, MenuItem, Pagination, Select, Skeleton, TextField, Menu, } from '@mui/material'
import InputSearch from '../../../../component/InputSearch'
import { getBranchList, getStock } from '../../services/api'
export default function RawBalance() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    let id = searchParams.get('id') || ''
    let b = searchParams.get('b') || 'all'
    let l = searchParams.get('l') || ''
    let c = searchParams.get('c') || ''
    let sum = searchParams.get('sum') || ''
    let page = searchParams.get('page') || '1'
    const [data, setData] = useState([])
    const [rowsPerPage] = useState(10);
    const { profile } = useSelector(state => state.profile)
    const [branchs, setBranchs] = useState([])
    const [item, setItem] = useState()
    const [departments, setDepartments] = useState([])
    const [materials, setMaterials] = useState([])
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);

    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        const getBranch = async () => {
            const data = await getBranchList()
            setBranchs(data)
        }

        getBranch()

    }, [])
    useEffect(() => {
        const getList = async () => {
            setLoading(true)
            const data = await getStock(l, sum, b, c, page, rowsPerPage)
            setData(data)
            setLoading(false)
        }
        getList()
    }, [b, c, l, page, sum, rowsPerPage])
    return (
        <Page>
            <TitlePage title='รายการเมล็ดพันธุ์ดิบคงคลัง' action={
                <>
                    {/* <AddButton link={'/materials/materials-expenses/add'} /> */}
                    <div class="col-lg-2 col-md-6 d-flex align-items-center justify-content-center">
                        <FormControlLabel control={<Checkbox checked={sum === 'true' ? true : false} onChange={e => setSearchParams({ sum: e.target.checked, l: l, b: b, c: c })} />} label="รวมรายพันธุ์" />
                    </div>
                    {
                        profile?.BranchNo?.BranchNo === '00' &&
                        <Box className="col-lg-2 col-md-12 ">
                            <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                                <FormControl variant="standard" fullWidth >
                                    <Select value={b || ''}
                                        onChange={e => setSearchParams({ sum: sum, c: c, b: e.target.value, l: l })}
                                        disableUnderline
                                        MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                    >
                                        <MenuItem value='all'>ศูนย์ทั้งหมด</MenuItem>
                                        {branchs?.map((x, i) => (
                                            <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box >
                    }



                    {/* <Box className="col-lg-2 col-md-12 ">
                        <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                            <FormControl variant="standard" fullWidth >
                                <Select value={c || ''}
                                    onChange={e => setSearchParams({ sum: sum, l: l, b: b, c: e.target.value })}
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    <MenuItem value='all'>สถานะทั้งหมด</MenuItem>
                                    <MenuItem value='ใช้งาน'>ใช้งาน</MenuItem>
                                    <MenuItem value='ชำรุด-รอซ่อม'>ชำรุด-รอซ่อม</MenuItem>
                                    <MenuItem value='ชำรุด-ตัดบัญชี'>ชำรุด-ตัดบัญชี</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </Box > */}
                    <div class="col-lg-3 col-md-12 text-end" >
                        <Box className='backgroundField' style={{ marginRight: '20px' }}>
                            <TextField value={c} onChange={e => setSearchParams({ sum: sum, c: e.target.value, b: b, l: l, })} variant="standard" fullWidth placeholder="ค้นหา พันธ์ุ"
                                InputProps={{ disableUnderline: true }}
                            />
                        </Box>
                    </div>
                    <InputSearch value={l} onChange={e => setSearchParams({ sum: sum, l: e.target.value, b: b, c: c, })} placeholder={"ค้นหาเลขที่ล็อต"} />
                </>
            } />
            <div class="receive-list row">
                {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :

                    <div class="col-md-12 table-responsive-sm pb-3">
                        <table class="table table-borderless table-hover ">
                            <thead>
                                <tr>
                                    <th class="text-center">ที่</th>
                                    {profile?.BranchNo?.BranchNo === '00' && <th class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>}
                                    <th class="text-center">พันธุ์</th>
                                    <th class="text-center"> ชั้นพันธุ์</th>
                                    <th class="text-center">ฤดู</th>
                                    <th class="text-center">ปี</th>
                                    {sum !== 'true' && <th class="text-center">ล็อตที่</th>}
                                    <th class="text-center">ปริมาณ (กิโลกรัม)</th>
                                    {sum !== 'true' && <th class="text-center">จำนวนวันที่อยู่ในคลัง</th>}
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody class="">
                                {data?.items?.map((x, i) => (
                                    <tr>
                                        <td class="text-center">{(data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i}</td>
                                        {profile?.BranchNo?.BranchNo === '00' && <td className="text-center">{x?.BranchNo?.BranchName}</td>}
                                        <td class="text-center">{x?.ItemNo?.CatalogNo?.CatalogName}</td>
                                        <td class="text-center">{x?.ItemNo?.Option2}</td>

                                        <td class="text-center">
                                            <span style={{ fontWeight: "bold", color: x?.Season === 'ฝน' ? '#0D9206' : 'brown' }}> {x?.Season}</span>
                                        </td >
                                        <td class="text-center">{x?.Year}</td>
                                        {sum !== 'true' && <td class="text-center">{x?.Lot}</td >}
                                        <td class="text-center">{x?.Balance.toLocaleString()}</td>
                                        {sum !== 'true' && <td class="text-center"><span style={{ color: x.DaysInStock > 240 ? '#E82900' : x.DaysInStock <= 180 ? '#000' : '#ECA904' }}>{x?.DaysInStock}</span></td >}
                                        <td class="text-center">
                                            {/* <Link to={`/raw/repurchase/add`} style={{ marginRight: "10px" }}>
                                                <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>รับ</Button>
                                            </Link>
                                            <Link to={`/raw/paidforfactory/add`} style={{ marginRight: "10px" }} >
                                                <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>จ่าย</Button>
                                            </Link>
                                            <Link to={`/raw/paidforfactory/add`} style={{ marginRight: "10px" }}>
                                                <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>รับหลังปรับปรุง</Button>
                                            </Link>
                                            <Link to={`/raw/paidforfactory/add`} >
                                                <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>จ่ายให้งานตลาด</Button>
                                            </Link> */}
                                            <Button onClick={(e) => {
                                                handleClick(e)
                                                setItem(x)
                                                }} variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>ดำเนินการ</Button>

                                        </td>
                                    </tr >
                                ))}

                            </tbody >
                        </table >
                    </div >}
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                    PaperProps={{
                        style: {
                            width: 220,
                        },
                    }}
                >

                    <MenuItem onClick={() => {navigate('/raw/repurchase/add', {state: item})}}>รับเมล็ดพันธ์ุดิบ</MenuItem>
                    <MenuItem onClick={() => {navigate('/raw/paidforfactory/add', {state: item})}}>จ่ายเพื่อปรับปรุง</MenuItem>
                    <MenuItem onClick={() => {navigate('/raw/receivedafterimprovement/add', {state: item})}}>รับหลังปรับปรุง</MenuItem>
                    <MenuItem onClick={() => {navigate('/raw/paidformarketing/add', {state: item})}}>จ่ายให้งานตลาด</MenuItem>
                </Menu>
                <div class="col-md-12 text-center mt-4">
                    <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={data?.meta?.totalPages} page={+page} onChange={(event, value) => setSearchParams({ page: value, l: l, c: c, b: b, id: id })} shape="rounded" />
                </div>
            </div >
        </Page>
    )
}
